import { ISubscription } from "../types/subscription";

export const initialSubscriptionPlan: ISubscription = {
    planType: ""
};